import $ from 'jquery';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { OverridableToolbarView } from '@bingads-webui/toolbar';
import { HotelDimensionRow as schema } from '@bingads-webui/hotel-odata-schemas';
import { conversionColumns, conversionColumnList } from './hotel-center-conversion-columns';
import { instrumentation } from '../hotel-center-shared';
import { inlineDownloadUtils } from '../hotel-center-utils';

const s$i18n = globalContext.require('$/schema-i18n!hotel-center');
const edm = globalContext.requireDefault('campaignui/feature/hotel-center-edm/index');
const config = globalContext.require('component/config/index');
const jsdata = globalContext.require('campaignui/feature/hotel-center-js-data/index');
const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const { DownloadView } = globalContext.require('campaignui/feature/griddownload/view/adapter');
const state = globalContext.require('component/state/index');
const pageContext = globalContext.require('PageContext');

const biPerformanceColumns = ['Impressions', 'Clicks', 'CTR', 'AverageCPC', 'AverageCPCUSD', 'AveragePosition', 'Spend', 'SpendUSD'];
const {
  Columns: ColumnsResource,
  SelectedColumns: SelectedColumnsResource,
} = globalContext.require('component/bingads-grid/service/column-chooser-preferences');

const getColumnChooserConfig = ({
  columnsPrev,
  attributesColumns,
  performanceColumns,
}) => ({
  categories: _.compact([{
    name: i18n.getString('Attributes'),
    options: _.map(attributesColumns, ({ name, title }) => ({
      key: name,
      name: title,
    })),
  }, {
    name: i18n.getString('Performance'),
    options: _.map(performanceColumns, ({ name, title }) => ({
      key: name,
      name: title,
      selectOption: 'optional',
    })),
  }, {
    name: i18n.getString('Conversions'),
    options: _.map(conversionColumns(''), ({ name, title }) => ({
      key: name,
      name: title,
      selectOption: 'optional',
    })),
  }]),
  selected: columnsPrev.concat(['Clicks', 'Impressions', 'CTR', 'Spend', 'SpendUSD', 'AverageCPC', 'AveragePosition']),
  locked: columnsPrev,
  customToolbarIcon: 'ba-TripleColumnSolid',
  Columns: ColumnsResource,
  SelectedColumns: SelectedColumnsResource,
  i18n,
  isForVNext: true,
  isHotelCenterGrid: true,
});

export default class Options {
  constructor({
    gridName,
    dateFilterContainer,
    columnsPrev,
    preferenceService,
    p$daterange,
    filterService,
  }) {
    this.i18n = i18n;
    this.name = gridName;
    this.filterService = filterService;
    this.p$daterange = p$daterange;
    const pageSizes = [20, 50, 100, 200];
    const entitySet = edm.currentAccount['Default.PerformanceReport'];
    const selectColumn = columnsPrev.concat(biPerformanceColumns.concat(conversionColumnList)).join(',');
    const permissions = pageContext.Permissions;

    this.preferenceService = preferenceService;
    this.config = config;
    this.tableClasses = ['table', 'table-bordered'];
    this.scrolling = {
      virtualized: true,
      viewport: window,
      header: {
        type: 'sticky',
        offset() {
          return $('.navbar-fixed-top').height();
        },
      },
    };
    this.dataSource = {
      type: 'js-data',
      entity: jsdata.HotelDimensionRow,
      options: {
        entitySet,
        cacheResponse: false,
      },
      query: {
        $select: selectColumn,
      },
    };

    this.performanceColumns = [bingadsGridColumn({
      name: 'Clicks',
      field: 'Clicks',
      type: 'number',
      format: 'integer',
      sortable: true,
      title: 'HotelCenter_Overview_Grid_Clicks_Label',
      helpId: 'pop_BA_HotelAds_Clicks',
      i18n: this.i18n,
    }), bingadsGridColumn({
      name: 'Impressions',
      field: 'Impressions',
      sortable: true,
      type: 'number',
      format: 'integer',
      title: 'HotelCenter_Overview_Grid_Impression_Label',
      helpId: 'pop_BA_HotelAds_Impressions',
      i18n: this.i18n,
    }), bingadsGridColumn({
      name: 'CTR',
      field: 'CTR',
      sortable: true,
      type: 'number',
      format: 'percentage-value',
      title: 'HotelCenter_Overview_Grid_CTR_Label',
      helpId: 'pop_BA_HotelAds_CTR',
      i18n: this.i18n,
    }), bingadsGridColumn({
      name: 'Spend',
      field: 'Spend',
      sortable: true,
      type: 'number',
      title: 'HotelCenter_Overview_Grid_Spend_Label',
      helpId: 'pop_BA_HotelAds_Spend',
      i18n: this.i18n,
    }), bingadsGridColumn({
      name: 'SpendUSD',
      field: 'SpendUSD',
      sortable: true,
      type: 'number',
      title: 'HotelCenter_Overview_Grid_Spend_USD_Label',
      helpId: 'pop_BA_HotelAds_Spend',
      i18n: this.i18n,
    }), bingadsGridColumn({
      name: 'AverageCPC',
      filed: 'AverageCPC',
      sortable: true,
      type: 'number',
      title: this.i18n.getString('HotelCenter_Overview_Grid_AverageCPC_Label'),
    }), bingadsGridColumn({
      name: 'AverageCPCUSD',
      filed: 'AverageCPCUSD',
      sortable: true,
      type: 'number',
      title: this.i18n.getString('HotelCenter_Overview_Grid_AverageCPC_USD_Label'),
    })];

    if (!permissions.IsAvgPositionDeprecationPhase3Enabled) {
      this.performanceColumns.push(bingadsGridColumn({
        name: 'AveragePosition',
        filed: 'AveragePosition',
        sortable: true,
        type: 'number',
        title: this.i18n.getString('HotelCenter_Overview_Grid_AveragePosition_Label'),
      }));
    }

    this.columns = this.performanceColumns;
    this.columns = this.performanceColumns.concat(conversionColumns(''));

    const items = [
      {
        type: 'button',
        id: 'button-download',
      }, {
        type: 'dropdown',
        id: 'dropdown-column-chooser',
      },
    ];

    this.gridToolbar = new OverridableToolbarView({
      toolbarId: _.uniqueId('grid-toolbar-'),
      items,
    }).render();
    $('.hotel-center-global-toolbar-containter .global-toolbar-container').append(this.gridToolbar.$el);

    this.plugins = {
      performanceLogNew: {
        instrumentation,
      },
      pagination: {
        pageSize: 20,
        availablePageSizes: pageSizes,
        enableRandomPage: false,
        pageSizeText: this.i18n.getString('Grid_ShowRows'),
        totalPageCountText: this.i18n.getString('Grid_PageOf'),
      },
      dateFilter: {
        container: dateFilterContainer,
        isComparisonEnabled: false,
        isCustomRangeEnabled: true,
      },
      uiBlocker: {
        el: $('.hotel-center-overview-page'),
      },
      placeholder: {
        filteredContainer: '.grid-noresult',
        filteredEmptyText: i18n.getString('HotelCenter_Grid_NoFilteredRecords'),

        container: '.grid-noresult',
        text: this.i18n.getString('HotelCenter_Grid_NoRecords'),
      },
      editable: {
        i18n: this.i18n,
      },
      columnChooser: getColumnChooserConfig({
        columnsPrev,
        attributesColumns: [],
        performanceColumns: this.performanceColumns,
      }),
      inlineDownload: {
        isForVNext: true,
        i18n,
        DownloadView,
        isAvailable: true,
        schema: _.defaults({
          name: 'DimensionRow',
        }, schema),
        s$i18n,
        p$daterange,
        gridId: gridName,
        toolbar: undefined,
        downloadFormats: ['Csv', 'Csvzip'],
        processReportRule: inlineDownloadUtils.processReportRuleForHotelCenterBIDimensionRow,
        ReportEmailRule: (() => {
          const ReportEmailRule = state.get('$ReportEmailRule');
          state.unset('$ReportEmailRule');
          return _.isObject(ReportEmailRule) ? ReportEmailRule : null;
        })(),
      },
    };
  }
}
